import React from "react";
import styles from "./styles.module.scss";

const Spinner = () => {
  return <div className={styles["spin"]} />;
};

export default Spinner;
